import { Injectable } from "@angular/core";
import { PropertyBookletCertificationType } from "./property-booklet-certification-card.component";

@Injectable()
export class PropertyBookletCertificationService {

  

  public static getTitle(type: PropertyBookletCertificationType): string {
    let title = '';
    switch (type) {
      case PropertyBookletCertificationType.energy:
        title = 'DPE';
        break;
      case PropertyBookletCertificationType.quality:
        title = 'Qualités du bâtiment';
        break;
      case PropertyBookletCertificationType.re2020:
        title = 'RE2020';
        break;
      default:
        console.error('PropertyBookletEquipmentService.getTitle(): Undefined title')
        break;
    }
    return title;
  }
}